import React from 'react';

const SuccessComponent = props => (
  <svg width={16} height={16} {...props}>
    <defs>
      <circle id="prefix__a" cx={8} cy={8} r={8} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="prefix__b" fill="#fff">
        <use xlinkHref="#prefix__a" />
      </mask>
      <use fill="#46CF84" xlinkHref="#prefix__a" />
      <g mask="url(#prefix__b)">
        <path d="M0 0h16v16H0z" fill="#16DB44" />
        <path
          d="M6.58 10.903L3.764 8.087a.678.678 0 0 1-.007-.949.67.67 0 0 1 .95.006l2.35 2.351L11.3 5.254a.674.674 0 0 1 .944-.002.67.67 0 0 1-.002.944L7.53 10.908a.674.674 0 0 1-.95-.005z"
          fill="#FFF"
        />
      </g>
    </g>
  </svg>
);

export default SuccessComponent;



// WEBPACK FOOTER //
// ./src/components/Form/FormHelper/iconComponent/successCmp.js